
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

const MESSAGES = defineMessages({
  SearchPlaceholder: {
    id: "SearchPlaceholder.placeholder",
    defaultMessage: "What are you looking for?",
  },
  SearchPlaceholderTroughs: {
    id: "SearchPlaceholder.placeholderTroughs",
    defaultMessage: "Search for a trough",
  }
});

export default MESSAGES;